// extracted by mini-css-extract-plugin
export var cell = "paintingGrid-module--cell--d5Tde";
export var grid = "paintingGrid-module--grid--mtbst";
export var header = "paintingGrid-module--header--7+ZhG";